declare const __APP_ENV__: "dev" | "prod" | "test";
declare const __REST_HOSTNAME__: string;

export const APP_ENV = __APP_ENV__;
export const REST_HOSTNAME = __REST_HOSTNAME__;
